module.exports = __webpack_public_path__ + "img/open_app.5c2b4c1.svg";